import toast from 'react-hot-toast';

export const toastSuccessIfMessage = (payload: { message?: string } | null | undefined) => {
  if (payload?.message) {
    toast.success(payload.message);
  }
};
